export default "__VITE_ASSET__BVJB8_$5__"